import { ProductInterface } from "../../interfaces/product.interface";
import { ProductActionType } from "../../interfaces/product-action-type.enum";

export interface ProductReducerInterface {
    products: ProductInterface[];
    isLoaded: boolean;
    isEmpty: boolean;
}

const initState: ProductReducerInterface = {
    products: [],
    isLoaded: true,
    isEmpty: false,
};

const productReducer: any = (
    state = initState,
    action: { type: ProductActionType; products: ProductInterface[] }
) => {
    switch (action.type) {
        case ProductActionType.ADD_PRODUCTS:
            const existingProducts = new Set(
                state.products.map((product) => product.id)
            );
            return {
                ...state,
                products: [
                    ...state.products,
                    ...action.products.filter(
                        (newProduct) => !existingProducts.has(newProduct.id)
                    ),
                ],
                isLoaded: true,
                isEmpty: false,
            };
        case ProductActionType.PRODUCTS_LOADING_ERROR:
            return {
                isLoaded: true,
                isEmpty: true,
            };
        default:
            return state;
    }
};

export default productReducer;
